import { api, resolveUrl } from "../../../../config/apis";
import AdminApi from "../../../../config/apis/admin";
import { useState, useEffect, useCallback } from "react";
import { SERVER_KEY } from "../../../../config/constants/EnviormentVariables";
import { useParams } from "react-router-dom";

export const useCreateCsv = (currentValue, filters) => {
  const param = useParams();

  const [reportData, setReportData] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      // Mirror the Datatable's param shape so the CSV respects the same
      // search/date filters that are applied to the on-screen table.
      const { campus_location, ...otherFilters } = filters || {};

      const params = {
        sort_order: currentValue,
        download_csv: true,
        filters: {
          ...otherFilters,
        },
      };

      if (campus_location) {
        params.campus_location = campus_location;
      }

      const response = await api.get(
        resolveUrl(AdminApi.JOBS_APPLICANTS, param.id),
        {
          params,
        }
      );

      const data = response.data.data ? response.data.data : [];

      const modifiedData = data.map((item) => {
        const { profile_image, resume, ...rest } = item;

        const Resume = `${SERVER_KEY}${resume}`;

        return { ...rest, Resume };
      });

      setReportData(modifiedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [currentValue, filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { reportData };
};
